/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, August 18th 2023, 4:22:45 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import CreditCardIcon from "@mui/icons-material/CreditCard";
import SettingsIcon from "@mui/icons-material/Settings";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { PaymentMethod, BillingConfiguration } from "lib/schemas";
import { StyledOSDialog } from "ui-widgets";
import { PaymentProviderCredentials } from "./PaymentProviderCredentials";

interface BillingConfigurationPaymentProviderCredentialsButtonProps {
  billingConfigurationId: BillingConfiguration["id"];
  paymentProvider: PaymentMethod;
}

export const BillingConfigurationPaymentProviderCredentialsButton = ({
  billingConfigurationId,
  paymentProvider,
}: BillingConfigurationPaymentProviderCredentialsButtonProps) => (
  <StyledOSDialog
    popUpTitle={`${paymentProvider.name} Credentials`}
    popUpIcon={<CreditCardIcon color="primary" />}
    maxWidth="sm"
    renderOpenButton={({ handleOpen }) => (
      <Tooltip title={<Typography>Configure {paymentProvider.name} Credentials</Typography>}>
        <IconButton color="secondary" onClick={handleOpen}>
          <SettingsIcon />
        </IconButton>
      </Tooltip>
    )}
  >
    <PaymentProviderCredentials paymentMethod={paymentProvider} billingConfigurationId={billingConfigurationId} />
  </StyledOSDialog>
);
